<div class="shared-modal-basic-container">

  <div class="modal-header">
    <div class="modal-toolbar">
      <div class="modal-title-container">
        <div>
          <div>{{ modalTitle }}</div>
          <span></span>
          @if (buttonCloseCross) {
            <app-shared-button (buttonClicked)="onButtonPress('button-close')" [fill]="false">
              @if (buttonCloseCross) {
                <app-display-icon [icon]="icons.closeBoxOutline"></app-display-icon>
              }
            </app-shared-button>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="app-content">
    @if (modalTitleIcon || contextHeading) {
      <div class="context-header-container">
        @if (modalTitleIcon) {
          @if (modalTitleIcon) {
            <app-display-icon
              [colour]="modalTitleIconColor" [icon]="modalTitleIcon" class="title-icon">
            </app-display-icon>
          }
        }
        @if (contextHeading) {
          <div>{{ contextHeading }}</div>
        }
      </div>
    }

    @if (contextDescription) {
      <div class="context-description-container">
        @for (contextItem of contextDescription; track $index) {
          <div>{{ contextItem }}</div>
        }
      </div>
    }

    <div class="input-section">
      <div class="input-section-item">
        <div>
          <label>{{ inputHeading }}</label>
          @if (inputType === 'string') {
            <textarea
              [(ngModel)]="inputText"
              [placeholder]="inputPlaceholder">
            </textarea>
          }
          @if (inputType !== 'string') {
            <input
              [(ngModel)]="inputText"
              [placeholder]="inputPlaceholder"
              [type]="inputType"/>
          }
        </div>
      </div>
    </div>

  </div>

  @if (buttonClose || buttonAccept) {
    <div class="footer">
      @if (buttonClose) {
        <app-shared-button (buttonClicked)="onButtonPress('button-close')" [fill]="false">{{ buttonCloseText }}
        </app-shared-button>
      }
      @if (buttonSecondary) {
        <app-shared-button (buttonClicked)="onButtonPress('button-secondary')">{{ buttonSecondaryText }}
        </app-shared-button>
      }
      @if (buttonAccept) {
        <app-shared-button (buttonClicked)="onButtonPress('button-accept')" [fill]="true">{{ buttonAcceptText }}</app-shared-button>
      }
    </div>
  }

</div>
